import React, { useEffect } from "react";
import Slider from "../hero/Slider";
import DealsSection from "../Deals/DealsSection";
import GoogleReviews from "./GoogleReviews";
import AboutRasu from "./AboutRasu";
import { getUserIP } from "../APIS/FlightApi/FlightApi";
import OffersCarousel from "../Offers/OffersCarousel";
import WhyRasutrip from "./WhyRasutrip";

const Home = () => {
  useEffect(() => {
    (async () => {
      const ip = await getUserIP();
      localStorage.setItem("UserIp", ip);
    })();
  }, []);

  return (
    <div>
      <Slider />
      <WhyRasutrip />
      <OffersCarousel />
      <DealsSection />
      <AboutRasu />
      <GoogleReviews />
    </div>
  );
};

export default Home;
